import React, { useEffect, useState } from "react";
import {
	InvoicesTableTypeChip,
	/* InvoicesTableStatusChip,
	InvoicesTableUsageTitle,
	InvoicesTableUsageWrapper,
	InvoiceTableUsageBar,
	InvoiceTableUsageBarProgress, */
	InvoicesWrapper,
} from "./style";
/* import PdfIcon from "@/assets/img/ic_pdf_download.svg";
import IconButton from "@/components/Button/IconButton"; */
import Table from "@/components/Table/Table";
import TablePagination from "@mui/material/TablePagination";
import {
	PaymentHistoryCtlDto,
	PaymentHistoryListResponseDto,
	/* PaymentResponseDto, */
} from "@/api/interface";
import { useSnackbar } from "notistack";
import API from "@/api/serverCall";
import { format } from "date-fns";
import { numberWithCommas } from "@/utils/number";
import { toUpperCase } from "@/utils/string";
import { useTranslation } from "react-i18next";
/* import { getPlanStatusText } from "@/utils/plan";
import { PlanStatus } from "../../../../../types/plan";
import printBillPaper from "@/views/Organization/Billing/Invoices/printBillPaper";
import { useSelector } from "react-redux";
import { getCompanyInfo } from "@/redux/organization/selector"; */

export default function BillingInvoices() {
	const { t } = useTranslation();
	// const [beforeList, setBeforeList] = useState<PaymentResponseDto[]>([]);
	const [list, setList] = useState<PaymentHistoryListResponseDto[]>([]);
	const { enqueueSnackbar } = useSnackbar();
	/* const companyInfo = useSelector(getCompanyInfo); */

	const [page, setPage] = React.useState(0);
	const [curRowsPerPage, setCurRowsPerPage] = React.useState(10);
	const [totalRows, setTotalRows] = React.useState(0);

	const handleChangePage = (
		event: React.MouseEvent<HTMLButtonElement> | null,
		newPage: number,
	) => {
		setPage(newPage);
		searchInvoiceList(newPage, curRowsPerPage);
	};

	const handleChangeRowsPerPage = (
		event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
	) => {
		setCurRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
		searchInvoiceList(0, parseInt(event.target.value, 10));
	};

	const searchInvoiceList = async (pageNumber: number, rowsPerPage: number) => {
		try {
			const { data } = await API.get<PaymentHistoryCtlDto>({
				link: "/payment/history",
				params: {
					page: pageNumber + 1,
					pageSize: rowsPerPage,
				},
			});
			setList(data.body.list);
			setTotalRows(data.body.totalSize);
		} catch (e) {
			enqueueSnackbar("정보를 불러오지 못했습니다.", {
				variant: "error",
			});
		}
	};

	/* const fetchData = async () => {
		try {
			const { data } = await API.get<PaymentHistoryCtlDto>({
				// link: "/payment/list",
				link: "/payment/history",
				params: {
					page: page + 1,
					pageSize: rowsPerPage,
				},
			});

			setList(data.body.list);
			setTotalRows(data.body.totalSize);
			console.log(data.body);
			const { data: ddd } = await API.get<PaymentResponseDto[]>({
				link: "/payment/list",
			});

			setBeforeList(ddd);
			// console.log(ddd);
		} catch (e) {
			enqueueSnackbar("정보를 불러오지 못했습니다.", {
				variant: "error",
			});
		}
	}; */

	/* const handleClickIconButton = (data: PaymentResponseDto) => {
		if (!companyInfo) {
			return;
		}
		printBillPaper(data, companyInfo);
	}; */

	useEffect(() => {
		// fetchData();
		searchInvoiceList(0, 10);
	}, []);

	return (
		<InvoicesWrapper>
			{/* <DataGrid
				rows={list}
				columns={columns}
				initialState={{
				  pagination: {
					paginationModel: {
					  pageSize: 5,
					},
				  },
				}}
				pageSizeOptions={[5]}
				checkboxSelection
				disableRowSelectionOnClick
			/> */}
			{/* <Table
				noResultText="결제 내역이 없습니다."
				// col={[10, 10, 20, 10, 10, 10, 10]}
				col={[10, 10, 20, 10, 10]}
				headItems={[
					"발행날짜",
					"상품 유형",
					"청구 기간",
					// "상태",
					"총액",
					// "PDF",
					"사용량 (Calls)",
				]}
				headProps={[
					{},
					{},
					{},
					// {},
					{},
					// { padding: [2, 0, 2, 8] },
				]}
				rowItems={beforeList.map((paymentItem) => {
					const usage =
						Math.round(
							paymentItem.apiCountCurrent / paymentItem.apiCountTotal,
						) / 10;
					return [
						format(new Date(paymentItem.createAt), "yyyy-MM-dd"),
						<InvoicesTableTypeChip type={paymentItem.planType}>
							{toUpperCase(paymentItem.planType)}
						</InvoicesTableTypeChip>,
						`${format(
							new Date(paymentItem.startAt),
							"yyyy-MM-dd",
						)} ~ ${format(new Date(paymentItem.endAt), "yyyy-MM-dd")}`,
						`${numberWithCommas(paymentItem.amount)} ₩`,
						<InvoicesTableUsageWrapper>
							<InvoicesTableUsageTitle>
								{numberWithCommas(paymentItem.apiCountCurrent)}
							</InvoicesTableUsageTitle>
							<InvoiceTableUsageBar>
								<InvoiceTableUsageBarProgress
									fill={usage < 0 ? 1 : usage}
								>
									{" "}
								</InvoiceTableUsageBarProgress>
							</InvoiceTableUsageBar>
						</InvoicesTableUsageWrapper>,
					];
				})}
				rowProps={[{ padding: [14, 0] }]}
			/> */}
			<Table
				noResultText={t("organization_billing.invoices_no_searched_record")}
				// col={[10, 10, 20, 10, 10, 10, 10]}
				col={[20, 20, 20, 20, 20]}
				headItems={[
					t("organization_billing.invoices_invoice_date"),
					t("organization_billing.invoices_product_type"),
					"APP",
					t("organization_billing.invoices_billing_period"),
					// "상태",
					t("organization_billing.invoices_total_amount"),
					// "PDF",
				]}
				headProps={[
					{},
					{},
					{},
					// {},
					{},
					// { padding: [2, 0, 2, 8] },
				]}
				rowItems={list.map((paymentItem) => {
					/* const usage =
						Math.round(
							paymentItem.apiCountCurrent / paymentItem.apiCountTotal,
						) / 10; */
					return [
						format(new Date(paymentItem.startAt), "yyyy-MM-dd"),
						<InvoicesTableTypeChip type={paymentItem.planType}>
							{toUpperCase(paymentItem.planType)}
						</InvoicesTableTypeChip>,
						paymentItem.isFoodLens ? "FoodLens" : "CaloAI",
						`${format(
							new Date(paymentItem.startAt),
							"yyyy-MM-dd",
						)} ~ ${format(new Date(paymentItem.endAt), "yyyy-MM-dd")}`,
						`${numberWithCommas(paymentItem.amount)} ₩`,
					];
				})}
				rowProps={[{ padding: [14, 0] }]}
			/>
			<TablePagination
				component="div"
				count={totalRows}
				page={page}
				onPageChange={handleChangePage}
				rowsPerPage={curRowsPerPage}
				rowsPerPageOptions={[5, 10, 20]}
				onRowsPerPageChange={handleChangeRowsPerPage}
			/>
		</InvoicesWrapper>
	);
}
